import { render, staticRenderFns } from "./firstinit.vue?vue&type=template&id=08c7e0c9&scoped=true"
import script from "./firstinit.vue?vue&type=script&lang=js"
export * from "./firstinit.vue?vue&type=script&lang=js"
import style0 from "./firstinit.vue?vue&type=style&index=0&id=08c7e0c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7e0c9",
  null
  
)

export default component.exports